<script setup>
import MessagesAdjusterComponent from "@/Components/Messaging/MessagesAdjusterComponent.vue";
import FinanceStatsComponent from "@/Components/FinanceStats/FinanceStatsComponent.vue";
import PayPeriodsComponent from "@/Components/PayPeriod/PayPeriodsComponent.vue";
import OutstandingHoldbacksComponent from "@/Components/HoldBacks/OutstandingHoldbacksComponent.vue";
import ClientRevenueComponent from "@/Components/ClientRevenue/ClientRevenueComponent.vue";
import FinanceIssuesComponent from "@/Components/FinanceIssues/FinanceIssuesComponent.vue";
import FinancialsClientCollectionsTable from "@/Components/Reports/FinancialsClientCollectionsTable.vue";
import {Permissions} from "@/Utils/Permissions";
</script>

<template>
  <v-row v-if="Permissions.checkPermissions(['messages.list'])">
    <v-col cols="12">
      <MessagesAdjusterComponent/>
    </v-col>
  </v-row>
  <v-row v-if="Permissions.checkPermissions(['financials.stats'])">
    <v-col cols="12">
      <FinanceStatsComponent/>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="6" v-if="Permissions.checkPermissions(['pay-periods.list'])">
      <PayPeriodsComponent/>
    </v-col>
    <v-col cols="6" v-if="Permissions.checkPermissions(['holdbacks.outstanding'])">
      <OutstandingHoldbacksComponent/>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="6" v-if="Permissions.checkPermissions(['financials.client-revenue'])">
      <ClientRevenueComponent/>
    </v-col>
    <v-col cols="6" v-if="Permissions.checkPermissions(['financials.issues'])">
      <FinanceIssuesComponent/>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="12" v-if="Permissions.checkPermissions(['financials.issues'])">
      <FinancialsClientCollectionsTable/>
    </v-col>
  </v-row>
</template>

<style scoped>

</style>